import { render, staticRenderFns } from "./newsPanel.vue?vue&type=template&id=5deaf4c4&scoped=true"
import script from "./newsPanel.vue?vue&type=script&lang=js"
export * from "./newsPanel.vue?vue&type=script&lang=js"
import style0 from "./newsPanel.vue?vue&type=style&index=0&id=5deaf4c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deaf4c4",
  null
  
)

export default component.exports